import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Constants } from 'src/app/config/constants';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { DeliveryDayPreferenceComponent } from 'src/app/components/delivery-day-preference/delivery-day-preference.component';
import { DeliveryQuantityComponent } from 'src/app/components/delivery-quantity/delivery-quantity.component';
import { CatalogueService } from 'src/app/lib/services/catalouge.service';
import { CommonService } from 'src/app/lib/services/common.service';
import { OptionsMenuComponent } from 'src/app/components/options-menu/options-menu.component';
import { UserService } from 'src/app/lib/services/user.service';
import { StorageService } from 'src/app/lib/services/storage.service';

@Component({
  selector: 'app-b2b-productlisting',
  templateUrl: './b2b-productlisting.component.html',
  styleUrls: ['./b2b-productlisting.component.scss'],
  standalone: false
})
export class B2bProductlistingComponent implements OnInit {
  cartPreviousData: any;
  previousCartData: any;
  modalData: any;
  defaultDate: any;
  selectedDate: any;
  flag: boolean;
  itemsInCart: any = [];
  Charges: any;
  addDisable: boolean = false;
  deliveryStatus: boolean = true;
  @ViewChild('search') search: ElementRef<any> | undefined;
  isSearch = false;
  searchText: any;
  searchResult: any;
  products = [];
  subCategories = [];
  categories = [];
  selectedCategory = 0;
  selectedSubCategory = 0;
  selectedMicroCategory = 1;
  productUserId = '';
  retailerID: any;
  cartData: any;
  shopStatus: string;
  vendorDetails: any;
  customerRating: any;
  currentAddress: any = this.storageService.getItem(Constants.USER_LOCATION) ? this.storageService.getItem(Constants.USER_LOCATION) : '';

  constructor(
    private route: ActivatedRoute,
    private modalCtrl: ModalController,
    private router: Router,
    private catalogueService: CatalogueService,
    public commonservice: CommonService,
    private userService: UserService,
    private storageService: StorageService,
  ) { }

  ngOnInit() {
    this.route.params.subscribe((res) => {
      if (res && res.id) {
        const { id } = res;
        this.productUserId = id;
        this.getStoreMetaData(id);
      }
    });
  }

  ionViewWillEnter() { }

  async getStoreMetaData(shopId: string) {
    try {
      this.commonservice.presentProgressBarLoading();
      const { lat, lon } = this.currentAddress;
      const res: any = await this.catalogueService.getStoreMetaData(lat, lon, shopId);
      if (!res?.data) return;
      if (typeof res.data === 'object' && res.data !== null && Object.keys(res.data).length > 0) {
        this.vendorDetails = res.data;
        this.shopStatus = res.data.shop_status;
        this.customerRating = this.vendorDetails.rating;
        this.setCart();
        this.cartData.cart?.length ? '' : (this.cartData.totalProducts = 0);
        this.retailerID = this.vendorDetails.user_id;
        if (this.vendorDetails.deliveryDistanceLimit < this.vendorDetails.distance) {
          this.deliveryStatus = false;
        }
        if (this.vendorDetails.store_meta[0]?.url) {
          this.getMerchantDetails();
          this.flag = false;
        } else {
          this.flag = true;
        }
      } else {
        this.flag = true;
        this.commonservice.closeProgressBarLoading();
      }
    } catch (error: any) {
      console.error(error);
      this.commonservice.errorToast(error);
      this.commonservice.closeProgressBarLoading();
    }
  }

  async favouriteShop() {
    const isLoading = await this.commonservice.presentLoader();
    isLoading.present();
    const { shop_id, isFavourite } = this.vendorDetails;
    const shopId = String(shop_id);
    this.userService.addFavourite({ shopId }).subscribe(res => {
      isLoading.dismiss();
      if (isFavourite) {
        this.commonservice.danger('Shop removed from favourites.');
      } else {
        this.commonservice.success('Shop added to favourites.');
      }
      this.vendorDetails.isFavourite = !this.vendorDetails.isFavourite;
    }, error => {
      isLoading.dismiss();
      this.commonservice.toast(error.error.error.message);
    });
  }

  setCart() {
    if (localStorage.getItem(Constants.CART_DATA)) {
      const data = this.storageService.getItem(Constants.CART_DATA);
      this.cartData = data;
      this.itemsInCart = [];
      this.cartData.cart.map((res: any) => {
        this.checkCartForItem(res);
      });
    } else {
      this.itemsInCart = [];
      this.cartData = {
        delivery: {
          location: {
            address: this.storageService.getItem(Constants.USER_LOCATION) ? this.storageService.getItem(Constants.USER_LOCATION).address : '',
            type: "Home",
            lat: this.storageService.getItem(Constants.USER_LOCATION).lat,
            lon: this.storageService.getItem(Constants.USER_LOCATION).lon,
          },
          mode: "PICKUP",
        },
        instructions: "",
        amount: 0,
        discount: 0,
        amountWithoutDiscount: 0,
        payment: {
          mode: "POSTPAID",
        },
        totalProducts: 0,
        cart: [],
      };
    }
  }

  searchProduct(e: any) {
    this.searchResult = [];
    this.vendorDetails.dataList?.catalog[this.selectedCategory]?.categories[this.selectedSubCategory].categories[this.selectedMicroCategory - 1].products.map(res => {
      if (res.name.toLowerCase().includes(e.target.value.toLowerCase())) {
        this.searchResult.push(res.id);
      }
    })
  }

  onClickSearch() {
    this.isSearch = !this.isSearch;
    if (this.isSearch == false) {
      this.searchText = "";
    }
  }

  async getMerchantDetails() {
    const isLoading = await this.commonservice.presentLoader();
    isLoading.present();
    this.catalogueService.getmerchant(this.vendorDetails.store_meta[0].url).subscribe((res) => {
      this.flag = false;
      isLoading.dismiss();
      this.customerRating = this.vendorDetails.rating;
      // res['catalog'].map(cat => {
      //   cat.categories.splice(0, 1)
      // })
      this.vendorDetails.dataList = res;
      if (!this.vendorDetails.dataList.catalog?.length) {
        this.flag = true
      }
      this.vendorDetails.dataList?.catalog?.map((res: any) => {
        this.populateData(res);
      })
      if (this.vendorDetails.dataList) {
        this.storageService.setCat(this.productUserId, this.vendorDetails.dataList)
      }
    }, err => {
      isLoading.dismiss();
      console.log(err)
      this.commonservice.danger(err.error?.error?.message)
    });
  }

  /**
   * @name populateData
   * @type Function - Get all categories and products
   * **/

  populateData(catalog: any): void {
    if (catalog.categories?.length) {
      catalog.categories.map((res: any) => {
        this.populateData(res)
      })
    } else {
      for (let i = 0; i < catalog.products?.length; i++) {
        catalog.products[i].unit = 1;
        catalog.products[i].quantity.minQty = catalog.products[i].quantity.minQty ? catalog.products[i].quantity.soldBy == 'Pcs' ? Math.ceil(parseFloat(catalog.products[i].quantity.minQty)) : parseFloat(catalog.products[i].quantity.minQty) : 1;
        catalog.products[i].isMandatory = false;
      }
    }
  }

  // Choose Date using calander icon.
  async selectDate(product: any, addToCart?: any, isQuantitySelected?: boolean) {
    if (!isQuantitySelected) {
      const item = {
        discount: product.price.preOrdDisc,
        grading: product.grd,
        id: product.id,
        image: product.media.img1,
        isMandatory: false,
        name: product.prdNm,
        price: product.price.mrp,
        qty: product.quantity.minQty !== null ? product.quantity.minQty : 1,
        quantity: product.quantity.minQty,
        soldBy: product.quantity.soldBy,
        status: product.status,
        unit: 1
      };
      this.addDisable = true
      this.cartPreviousData = this.cartData ? JSON.parse(JSON.stringify(this.cartData)) : [];
      const model = await this.modalCtrl.create({
        component: DeliveryDayPreferenceComponent,
        cssClass: 'DeliveryDayCalander-component-css',
        componentProps: {
          product: item,
          hideNow: true,
        },
      });
      await model.present();
      this.modalData = await model.onWillDismiss();
      this.addDisable = false
      if (addToCart) {
        this.addToCart(item)
      }
    } else {
      const item = product
      this.addDisable = true
      this.cartPreviousData = this.cartData ? JSON.parse(JSON.stringify(this.cartData)) : [];
      const model = await this.modalCtrl.create({
        component: DeliveryDayPreferenceComponent,
        cssClass: 'DeliveryDayCalander-component-css',
        componentProps: {
          product: item,
          hideNow: true,
        },
      });
      await model.present();
      this.modalData = await model.onWillDismiss();
      this.addDisable = false
      if (addToCart) {
        this.addToCart(item)
      }
    }
  }

  async quantity(product: any) {
    const item = {
      discount: product.price.preOrdDisc,
      grading: product.grd,
      id: product.id,
      image: product.media.img1,
      isMandatory: false,
      name: product.prdNm,
      price: product.price.mrp,
      qty: product.quantity.minQty !== null ? product.quantity.minQty : 1,
      quantity: product.quantity.minQty,
      soldBy: product.quantity.soldBy,
      status: product.status,
      unit: 1
    };
    this.addDisable = true
    const model = await this.modalCtrl.create({
      component: DeliveryQuantityComponent,
      cssClass: 'OtpBox-AddMember',
      componentProps: {
        unit: item.soldBy,
        price: item.price,
        moq: item.quantity
      },
    });
    await model.present();
    const { data } = await model.onWillDismiss();
    this.addDisable = false
    if (data != undefined) {
      if (data?.quantity) {
        this.selectDate(item, this.addToCart, true)
      }
      this.vendorDetails?.dataList.catalog.map(res => {
        this.updateQty(res, item, data);
      })
      item.qty = data?.quantity ? data.quantity : item.qty;
    } else {
      item.qty != item.quantity ? item.qty : item.quantity
    }
  }

  // Function to get current products based on selectedCategory, selectedSubCategory, and selectedMicroCategory
  getCurrentProducts(): any[] {
    if (this.vendorDetails?.dataList?.catalog &&
      this.vendorDetails.dataList.catalog[this.selectedCategory]?.categories) {
      if (this.selectedSubCategory === 0) {
        // If "All" or "Popular" category selected, return products directly from catalog
        return this.vendorDetails.dataList.catalog[this.selectedCategory]?.categories[this.selectedSubCategory].products || [];
      } else {
        // For other categories, navigate through the nested structure to retrieve the products
        return this.vendorDetails.dataList.catalog[this.selectedCategory].categories[this.selectedSubCategory]?.categories[this.selectedMicroCategory - 1]?.products || [];
      }
    }
    return [];
  }

  async addToCart(item: any) {
    // item.soldBy = this.vendorDetails?.dataList?.catalog[this.selectedCategory].key == 'restaurant' && item.soldBy == 'Pcs' ? 'Plt' : item.soldBy;
    // If date is not selected than default date is today
    this.defaultDate = new Date().toISOString().split('T')[0];
    this.previousCartData = this.cartPreviousData;
    this.selectedDate = this.modalData;
    if (this.previousCartData == undefined) {
      this.previousCartData = this.cartData;
    }
    const { data } = this.selectedDate;
    if (data) {
      const checkDateIndex = this.previousCartData.cart.findIndex(
        (x: any) => x.date === data.date
      );
      if (checkDateIndex > -1) {
        const slotIndex = this.previousCartData.cart[checkDateIndex].timeSlots.findIndex(
          (x: any) => x.timeSlot === "06AM-10PM"
        );
        if (slotIndex > -1) {
          const vendorIndex = this.previousCartData.cart[checkDateIndex].timeSlots[slotIndex].shops.findIndex(
            (x: any) => x.shopId === this.productUserId,
          );
          this.previousCartData.cart[checkDateIndex].timeSlots[slotIndex].shops.catalogVersion = this.vendorDetails.store_meta[0]?.version,
            this.previousCartData.cart[checkDateIndex].timeSlots[slotIndex].shops.catalogUrl = this.vendorDetails.store_meta[0]?.url;

          if (vendorIndex > -1) {
            const itemIndex = this.previousCartData.cart[checkDateIndex].timeSlots[slotIndex].shops[vendorIndex].products.findIndex(
              (x: any) => x.id === item.id && x.qty == item.qty
            );
            // console.log(itemIndex)
            if (itemIndex > -1) {
              this.previousCartData.totalProducts += 1;
              this.previousCartData.cart[checkDateIndex].timeSlots[slotIndex].shops[
                vendorIndex
              ].products[itemIndex].unit += 1;
            } else {
              this.previousCartData.totalProducts += 1;
              this.previousCartData.cart[checkDateIndex].timeSlots[slotIndex].shops[
                vendorIndex
              ].products.push(item);
            }
          } else {
            this.previousCartData.totalProducts += 1;
            this.previousCartData.cart[checkDateIndex].timeSlots[slotIndex].shops.push({
              shopId: this.productUserId,
              retailerId: this.retailerID,
              catalogUrl: this.vendorDetails.store_meta[0]?.url,
              catalogVersion: this.vendorDetails.store_meta[0]?.version,
              products: [item],
              distance: {
                shopDistance: this.vendorDetails.distance,
                deliveryDistanceLimit: this.vendorDetails.deliveryDistanceLimit
              },
              shop_name: this.vendorDetails.shop_name,
              deliveryChargesPerUnit: this.vendorDetails.deliveryCharges
            });
          }
        } else {
          this.previousCartData.totalProducts += 1;
          this.previousCartData.cart[checkDateIndex].timeSlots.push({
            timeSlot: "06AM-10PM",
            shops: [
              {
                shopId: this.productUserId,
                retailerId: this.retailerID,
                catalogUrl: this.vendorDetails.store_meta[0]?.url,
                catalogVersion: this.vendorDetails.store_meta[0]?.version,
                products: [item],
                distance: {
                  shopDistance: this.vendorDetails.distance,
                  deliveryDistanceLimit: this.vendorDetails.deliveryDistanceLimit
                },
                shop_name: this.vendorDetails.shop_name,
                deliveryChargesPerUnit: this.vendorDetails.deliveryCharges
              },
            ],
          });
        }
      } else {
        this.previousCartData.totalProducts += 1;
        this.previousCartData.cart.push({
          date: data.date,
          timeSlots: [
            {
              timeSlot: "06AM-10PM",
              shops: [
                {
                  shopId: this.productUserId,
                  retailerId: this.retailerID,
                  catalogUrl: this.vendorDetails.store_meta[0]?.url,
                  catalogVersion: this.vendorDetails.store_meta[0]?.version,
                  products: [item],
                  distance: {
                    shopDistance: this.vendorDetails.distance,
                    deliveryDistanceLimit: this.vendorDetails.deliveryDistanceLimit
                  },
                  shop_name: this.vendorDetails.shop_name,
                  deliveryChargesPerUnit: this.vendorDetails.deliveryCharges
                },
              ],
            },
          ],
        });
      }
      this.cartData = this.previousCartData;
      this.storageService.setItem(Constants.CART_DATA, this.previousCartData);
    }
    this.cartData.cart.map((res: any) => {
      this.checkCartForItem(res);
    })
  }

  addDateToProductDetails(selectedCartData: any, productId: any) {
    this.subCategories.map(subCat => {
      subCat.activeProducts.map(activeProd => {
        if (activeProd.id == productId) {
          activeProd.date = selectedCartData.cart;
        }
      });
    });
  }

  updateQty(catalog: any, item: any, data: any) {
    if (catalog.categories?.length) {
      catalog.categories.map((res: any) => {
        this.updateQty(res, item, data)
      })
    } else {
      for (let i = 0; i < catalog.products?.length; i++) {
        if (item.id == catalog.products[i].id) {
          catalog.products[i].qty = data?.quantity ? data.quantity : catalog.products.qty;
        }
      }
    }
  }

  async optionsMenu() {
    const model = await this.modalCtrl.create({
      component: OptionsMenuComponent,
      cssClass: 'OtpBox-AddMember',
      componentProps: {
        shopId: parseInt(this.productUserId),
        vendDetails: this.vendorDetails
      }
    });
    await model.present();
    const { data } = await model.onWillDismiss();
    if (data == 'fav') {
      this.favouriteShop();
    }
  }

  checkCartForItem(cart: any) {
    if (cart.timeSlots) {
      cart.timeSlots.map((res: any) => {
        this.checkCartForItem(res);
      })
    } else if (cart.shops) {
      cart.shops.map((res: any) => {
        this.checkCartForItem(res);
      })
    } else {
      for (let i = 0; i < cart.products.length; i++) {
        if (!this.itemsInCart.includes(cart.products[i].id)) {
          this.itemsInCart.push(cart.products[i].id);
        }
      }
    }
  }

  sellerProfile(details: any) {
    this.router.navigate([`/seller-profile/${details.shop_id}`], {
      state: { ...details }
    });
  }

  navigateToCart() {
    this.router.navigate(['b2b-cart']);
  }

}
